import React, { useState } from 'react'
import { Table } from '../../../../../../../components/Table'
import { TableHead } from '../../../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../../../components/Table/TableBody'
import { ITransactionLog } from '../../core/response.types'
import { DIRECTION_BADGE, DIRECTION_LABEL } from '../../core/consts'
import { convertUTCtoMSK } from '../../../../../../../utils'
import { LogDetailsModal } from '../common/LogDetailsModal'

interface ExternalTransactionLogsTableProps {
  logs: ITransactionLog[]
  isLoading: boolean
}

export const ExternalTransactionLogsTable: React.FC<ExternalTransactionLogsTableProps> = ({
  logs,
  isLoading,
}) => {
  const [selectedLog, setSelectedLog] = useState<ITransactionLog | null>(null)

  return (
    <>
      <Table>
        <TableHead>
          <tr>
            <th>Дата</th>
            <th>Направление</th>
            <th>Статус</th>
            <th>URL</th>
            <th>Kind</th>
            <th>Действия</th>
          </tr>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <tr>
              <td colSpan={6}>Идёт загрузка...</td>
            </tr>
          ) : logs.length ? (
            logs.map((log) => (
              <tr
                key={log.id}
                // style={{ cursor: 'pointer' }}
                // onClick={() => setSelectedLog(log)}
              >
                <td style={{ whiteSpace: 'nowrap' }}>{convertUTCtoMSK(log.created_at)}</td>
                <td>
                  <span className={`badge ${DIRECTION_BADGE[log.direction]}`}>
                    {DIRECTION_LABEL[log.direction]}
                  </span>
                </td>
                <td>
                  {log.status_code !== null ? (
                    <span
                      className={`badge ${log.status_code >= 200 && log.status_code < 300 ? 'badge-light-success' : 'badge-light-danger'}`}
                    >
                      {log.status_code >= 200 && log.status_code < 300 ? 'OK' : 'ERROR'}
                    </span>
                  ) : (
                    '—'
                  )}
                </td>
                <td
                  style={{
                    maxWidth: '300px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontFamily: 'monospace',
                    fontSize: '0.8rem',
                  }}
                  title={log.url ?? ''}
                >
                  {log.url || '—'}
                </td>
                <td>{log.kind || '—'}</td>
                <td>
                  <button
                    type='button'
                    className='btn btn-sm btn-light-primary'
                    onClick={(e) => {
                      e.stopPropagation()
                      setSelectedLog(log)
                    }}
                  >
                    Подробнее
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6}>Данных нет.</td>
            </tr>
          )}
        </TableBody>
      </Table>

      <LogDetailsModal log={selectedLog} onHide={() => setSelectedLog(null)} />
    </>
  )
}
